export function initTabs($tabs) {
    if (!$tabs) return;

    let defaultTab = $tabs.attr('data-default-tab');
    if (!defaultTab) {
        defaultTab = $tabs.find('[data-content-tab]').first().attr('data-content-tab');
    }

    changeTab(defaultTab);

    $tabs.on('click', '.switch', function () {
        if(!$(this).data('content-tab')){
            return;
        }
        if ($(this).hasClass('active')) return false;
        changeTab($(this).attr('data-content-tab'));
    });

    function changeTab(tab) {
        $tabs.find('[data-content-tab]').removeClass('active');
        $tabs.find('[data-content-tab="' + tab + '"]').addClass('active');
    }
}